import React, { useEffect, useState } from "react";
import "./OrderSuccessful.css";
import { useRecoilState } from "recoil";
import { orderSuccessfulProvider } from "../../Providers/OrderSuccessfulProvider";
import { IMAGE_URL1 } from "../../utils/apiURL";
import Loader from "../../components/Loader/Loader";
import { formatPrice } from "../../utils/helpers";

const OrderSuccessful = ({ orderid, message }) => {
  const [ordersuccesscont, setordersuccesscont] = useRecoilState(orderSuccessfulProvider);
  const [orderdata, setOrderdata] = useState(null);
  
  // Simuler la récupération des commandes dans le front-end
  const orders = JSON.parse(localStorage.getItem('orders')) || []; // Si vous avez les commandes stockées localement
  
  useEffect(() => {
    // Trouver la commande correspondante en fonction de l'order_id
    const order = orders.find((order) => order.order_id === orderid);
    setOrderdata(order); // Mettre à jour les données de la commande sélectionnée
  }, [orderid, orders]); // Recharger si l'orderid change

  if (!orderdata) {
    return <Loader />; // Afficher le loader tant que la commande n'est pas trouvée
  }

  const getStatusClassName = (status) => {
    switch (status) {
      case "1":
        return "status-pending"; // Orange
      case "2":
        return "status-confirmed"; // Green
      case "3":
        return "status-rejected"; // Red
      default:
        return "status-unknown"; // Default class
    }
  };

  return (
    <div className="OrdersSuccessful">
      <button
        className="popup__close-btn"
        onClick={() => {
          setordersuccesscont(false);
        }}
      >
        {/* Icon for closing the popup */}
      </button>

      <div className="confirmationcont">
        <div className="c1">
          <h2>{message}</h2>
        </div>

        <div className="c2">
          <h2>Order Summary</h2>
          <div>
            <p>Order Date</p>
            <p>{new Date(orderdata.order_date).toLocaleDateString()}</p>
          </div>
          <div>
            <p>Name</p>
            <p>{`${orderdata.user.firstname} ${orderdata.user.lastname}`}</p>
          </div>
          <div>
            <p>Email</p>
            <p>{orderdata.user.email}</p>
          </div>
          <div>
            <p>Mobile</p>
            <p>{orderdata.user.mobile}</p>
          </div>
          <div>
            <p>Order Total</p>
            <p>{formatPrice(orderdata.total)}</p>
          </div>
          <div>
            <p>Order Status</p>
            <p className={getStatusClassName(orderdata.status)}>
              {orderdata.status === "1"
                ? "On hold"
                : orderdata.status === "2"
                ? "Confirmed"
                : orderdata.status === "3"
                ? "Denied"
                : "Status unknown"}
            </p>
          </div>
        </div>

        <div className="c3">
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Product</th>
                <th>Price</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {orderdata.products && orderdata.products.length > 0 ? (
                orderdata.products.map((product) => (
                  <tr key={product.product_id}>
                    <td>
                      <img
                        src={`${IMAGE_URL1}${product.product_images1}`}
                        alt={product.product_name}
                        style={{ width: "50px" }}
                      />
                    </td>
                    <td>
                      <p>{product.product_name}</p>
                    </td>
                    <td>
                      <p>{formatPrice(product.total)}</p>
                    </td>
                    <td>
                      <p>{product.quantity}</p>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No products found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessful;
